import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const CompanyInfoContext = createContext({ info: {}, refresh: () => {} });

export function CompanyInfoProvider({ children }) {
  const [info, setInfo] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/company-info");
      setInfo(data || {});
    } catch (err) {
      // Preserve previous value; surface the failure so it isn't silently swallowed.
      console.error("CompanyInfoContext: failed to load /company-info", err);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ info, refresh }), [info, refresh]);

  return (
    <CompanyInfoContext.Provider value={value}>
      {children}
    </CompanyInfoContext.Provider>
  );
}

export const useCompanyInfo = () => useContext(CompanyInfoContext);
